export const API_URL_LOCAL = 'http://localhost:3002/v1';
export const API_URL_DEV ='https://api-dev.eposo.ai/v1';
export const API_URL_PROD ='https://api.eposo.ai/v1';

export const HOCUSPOCUS_URL_LOCAL = 'ws://localhost:1234';
export const HOCUSPOCUS_URL_DEV = 'wss://rt-dev.eposo.ai';
export const HOCUSPOCUS_URL_PROD = 'wss://rt.eposo.ai';

export const GET_HOCUSPOCUS_URL = () => {
  // console.log(`[GET_HOCUSPOCUS_URL] process.env.VUE_APP_MODE: ${process.env.VUE_APP_MODE}`);
  if (process.env.VUE_APP_MODE === 'LOCAL') {
    return HOCUSPOCUS_URL_LOCAL;
  } else if (process.env.VUE_APP_MODE === 'DEV') {
    return HOCUSPOCUS_URL_DEV;
  } else if (process.env.VUE_APP_MODE === 'PROD') {
    return HOCUSPOCUS_URL_PROD;
  }
};

export const GET_API_URL = () => {
  if (process.env.VUE_APP_MODE === 'LOCAL') {
    return API_URL_LOCAL;
  } else if (process.env.VUE_APP_MODE === 'DEV') {
    return API_URL_DEV;
  } else if (process.env.VUE_APP_MODE === 'PROD') {
    return API_URL_PROD;
  }
};

export enum apiStatus {
  SUCCESS = 200,
  SUCCESS_CREATED = 201,
}

export enum GlobalRole {
  ADMIN = 'Admin',
  DEPTH1 = '1Depth',
  DEPTH2 = '2Depth',
  CLIENT = 'Client',
}
